export default "__VITE_ASSET__DIUUrEhH__"